"use client";

import { CaptureError } from "@/shared-web.ui.logger/capture-error";
import { GenericError } from "@/stf.ui/ui.generic-error";

interface ErrorProps {
  error: { digest?: string } & Error;
  reset: () => void;
}
export default function Error(props: ErrorProps) {
  const { error, reset } = props;

  return (
    <CaptureError error={error}>
      <GenericError
        error={error}
        reset={reset}
      />
    </CaptureError>
  );
}
